import { grayColor } from 'assets/jss/material-dashboard-pro-react';

import typographyStyle from './typographyStyle';

const gobizTableStyle = (theme) => ({
	gobizTableWrapper: {
		margin: '-11px -52px',
	},
	customColumnWrapper: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		backgroundColor: grayColor[2],
		'& > .price': {
			paddingTop: 13,
			...typographyStyle(theme).headingSBold,
			'&:first-of-type': {
				paddingTop: 8,
			},
		},
		'& > .description': {
			paddingBottom: 13,
			textAlign: 'center',
			...typographyStyle(theme).caption,
			...typographyStyle(theme)['disabled-light'],
			'&:last-of-type': {
				paddingBottom: 8,
			},
		},
		'& > div': {
			width: '100%',
		},
	},
});

export default gobizTableStyle;
